module.exports = __webpack_public_path__ + "static/media/u50_premium_contract12.8bcde267.webp";